import { SPECIALIZATION_SUBSCRIPTION, VERIFIED_CERTIFICATE } from 'bundles/payments-common/common/ProductType';

export const collectionProductComparator = (productA: $TSFixMe, productB: $TSFixMe) => {
  if (productA.colIndex === productB.colIndex) {
    return productA.productId.localeCompare(productB.productId);
  } else {
    return productA.colIndex - productB.colIndex;
  }
};

const getProductsData = (products: $TSFixMe, courses: $TSFixMe, specializations: $TSFixMe) => {
  const productsWithData = products.sort(collectionProductComparator).map(({ productId, productType }: $TSFixMe) => {
    switch (productType) {
      case courses && VERIFIED_CERTIFICATE:
        return courses.find(({ id }: $TSFixMe) => id === productId);
      case specializations && SPECIALIZATION_SUBSCRIPTION:
        return specializations.find(({ id }: $TSFixMe) => id === productId);
      default:
        return null;
    }
  });
  return productsWithData.filter((product: $TSFixMe) => product !== null);
};

export default getProductsData;
